import { Link } from 'react-router-dom'

import { PageHeader } from '@/app/layouts/PageHeader'
import { EmptyState } from '@/components/ui/EmptyState'
import { useT } from '@/i18n'

export function NotFoundPage() {
  const t = useT()
  return (
    <>
      <PageHeader title={t('error.notFoundTitle')} back />
      <EmptyState
        title={t('error.notFoundBody')}
        description={
          <>
            {t('error.linkExpired')}
            <Link to="/" className="ml-1 text-brand-ink hover:underline">
              {t('error.backHome')}
            </Link>
          </>
        }
      />
    </>
  )
}
